__turbopack_context__.v({
  "footer": "dd4zVG_footer",
  "foreground": "dd4zVG_foreground",
  "header": "dd4zVG_header",
  "menu": "dd4zVG_menu",
});
